import { render, staticRenderFns } from "./enerji.vue?vue&type=template&id=5f5543e0&scoped=true&"
import script from "./enerji.vue?vue&type=script&lang=js&"
export * from "./enerji.vue?vue&type=script&lang=js&"
import style0 from "./enerji.vue?vue&type=style&index=0&id=5f5543e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5543e0",
  null
  
)

export default component.exports